<div
    *transloco="let t"
    [class]="'bazis-control ' + cssClassSizeControl"
>
    <bazis-button
        [fill]="fillButton"
        [color]="colorButton"
    >
        @if (icon()) {
            <bazis-icon
                slot="icon-only"
                [icon]="icon()"
            ></bazis-icon>
        } @else {
            @if (iconStart()) {
                <bazis-icon
                    slot="start"
                    [icon]="iconStart()"
                ></bazis-icon>
            }
            {{ t(buttonKey, buttonParams) }}
            @if (iconEnd()) {
                <bazis-icon
                    slot="end"
                    [icon]="iconEnd()"
                ></bazis-icon>
            }
        }

        <!-- TEMP, depricated -->
        @if (iconKey) {
            <bazis-icon
                [slot]="buttonKey ? 'start' : 'icon-only'"
                [icon]="iconKey"
            ></bazis-icon>
            {{ t(buttonKey, buttonParams) }}
        }

        <input
            type="file"
            [attr.multiple]="max > 1"
            (focus)="markAsTouched()"
            (change)="addFiles($event)"
        />
    </bazis-button>
    <ng-content></ng-content>
</div>
